import postAPI from './postAPI.js'

export default async function postCreateAction(actionData) {
    const data = await postAPI('admin/taskflows/actions/create', actionData);
    return data;
}
